import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByLastDayComponent } from './recurring-by-last-day.component';

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByLastDayComponent),
		InputComponentModule,
		SignpostComponentModule,
		TextComponentModule,
	],
	declarations: [
		RecurringByLastDayComponent
	],
	exports: [
		RecurringByLastDayComponent
	]
})
export class RecurringByLastDayModule { }
